import * as THREE from "three/webgpu";
import { useRef, useMemo } from "react";
import { WaterMesh } from "three/examples/jsm/objects/WaterMesh.js";

export default function Ocean({
  position = [0, 0, 0],
  rotation = [0, 0, 0],
  scale = [1, 1, 1],
  size = [10000, 10000],
  sunDirection = [0.70707, 0.70707, 0],
  sunColor = 0xffffff,
  waterColor = 0x003f5e,
  distortionScale = 3.7,
  ...props
}) {
  const waterRef = useRef();

  // Create water geometry
  const waterGeometry = useMemo(() => {
    return new THREE.CircleGeometry(size[0], size[1]);
  }, [size]);

  // Create water mesh
  const water = useMemo(() => {
    // Load water normals texture
    const loader = new THREE.TextureLoader();
    const waterNormals = loader.load("/waternormals.jpeg");
    waterNormals.wrapS = waterNormals.wrapT = THREE.RepeatWrapping;

    const waterInstance = new WaterMesh(waterGeometry, {
      waterNormals: waterNormals,
      sunDirection: new THREE.Vector3(...sunDirection),
      sunColor,
      waterColor,
      distortionScale,
    });

    waterInstance.rotation.x = -Math.PI / 2;
    return waterInstance;
  }, [waterGeometry, sunDirection, sunColor, waterColor, distortionScale]);

  return (
    <group position={position} rotation={rotation} scale={scale} {...props}>
      {/* Water */}
      <primitive ref={waterRef} object={water} receiveShadow />
    </group>
  );
}
